import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterCategory = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-category-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterCategory.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCategory.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterCategory.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterCategory;
